import { mapGetters, mapState, mapMutations } from 'vuex'

export const axeptio = {
  computed: {
    ...mapState({
      axeptioChoices: ({ axeptio }) => axeptio
    }),
    ...mapGetters({
      isEsrSsoRestriction: 'isEsrSsoRestriction',
      isESRMerge: 'user/isESRMerge'
    }),

    isAuthorizeIntercom () {
      return this.axeptioChoices.intercom && (!this.isEsrSsoRestriction || this.isESRMerge)
    }
  },

  methods: {
    ...mapMutations({
      setAxeptio: 'setAxeptio'
    }),

    // Axeptio must be loaded according to various conditions, which is why the code is not in index.html
    createAxeptioScriptTag () {
      if (!document.querySelectorAll('head > .axeptio').length) {
        const clientId = process.env.AXEPTIO_ID
        const head = document.querySelector('head')
        const script = document.createElement('script')

        script.classList.add('axeptio')

        const scriptContent = document.createTextNode(`
          window.axeptioSettings = {
            clientId: '${clientId}',
          };
  
          (function(d, s) {
            var t = d.getElementsByTagName(s)[0], e = d.createElement(s);
            e.async = true; e.src = "//static.axept.io/sdk.js";
            t.parentNode.insertBefore(e, t);
          })(document, "script");
        `)

        script.appendChild(scriptContent)
        head.appendChild(script)
      }
    },

    listenAxeptioValidation () {
      void 0 === window._axcb && (window._axcb = [])

      window._axcb.push((axeptio) => {
        axeptio.on('cookies:complete', (choices) => {
          this.setAxeptio(choices)
          this.loadIntercom()
        })
      })
    },

    loadIntercom () {
      if (this.$intercom) {
        if (this.isAuthorizeIntercom) {
          this.$intercom.boot()
        } else {
          this.$intercom.shutdown()
        }
      }
    },

    updateIntercom (profile) {
      if (this.$intercom && this.isAuthorizeIntercom) {
        this.$intercom.update(profile)
      }
    },

    shutDownIntercom () {
      if (this.$intercom) {
        this.$intercom.shutdown()
      }
    },

    contactAdvisor () {
      if (this.$intercom && this.isAuthorizeIntercom) {
        this.$intercom.show()
      } else {
        window.open(`mailto:${process.env.ADVISOR_EMAIL}`)
      }
    }
  }
}
